<template>

  <section class="header" :class="{ share: page === 'share' }">

    <div class="nav-wrapper">

      <!-- Logo -->
      <router-link to="/surveys">
        <img id="logo" src="../assets/logo.svg">
      </router-link>

      <!-- Nav -->
      <div v-if="!['surveys', 'settings'].includes(page) && !(this.survey && !this.survey.is_published)" id="navigation" :class="{
        answers_selected: page === 'answers',
        respondent_selected: page === 'respondent',
        respondents_selected: page === 'respondents'
        }">
        <div class="button-container" >
          <button @click="goToPage('share')" :class="{ selected: page === 'share' }" id="share-page-btn">Share</button>
          <button @click="goToPage('questions')" :class="{ selected: page === 'questions', sub_selected: !['share', 'questions'].includes(page) }" id="results-page-btn" >Results&nbsp;&nbsp;<span>✏️</span></button>
          <button v-if="page === 'answers'" :class="{ selected: page === 'answers' }" id="answers-page-btn" >Q{{ parseInt(question_index) + 1 }}&nbsp;&nbsp;<span>{{ question_type }}</span></button>
          <button v-if="page === 'respondent'" :class="{ selected: page === 'respondent' }" id="respondent-page-btn" >👨</button>
          <button v-if="page === 'respondents'" :class="{ selected: page === 'respondents' }" id="respondents-page-btn" >👨👩</button>
        </div>
        <div id="selected-slider" :class="{
          results_selected: page === 'questions',
          answers_selected: page === 'answers',
          respondent_selected: page === 'respondent',
          respondents_selected: page === 'respondents'
          }"></div>
      </div>


      <!-- Profile Dropdown or Create Account & Monthly Usage -->
      <div class="dropdown-container">

        <!-- Profile Dropdown -->
        <a-dropdown>
          <a class="ant-dropdown-link">
            {{ user.first_name || user.name || 'Profile' }} <a-icon type="down" />
          </a>
          <a-menu slot="overlay" class="dropdown">
            <a-menu-item @click="goToSettings">
              <a>Settings</a>
            </a-menu-item>
            <a-menu-item @click="goToFeedback">
              <a>Feedback</a>
            </a-menu-item>
            <!-- TODO: Ask for confirmation -->
            <a-menu-item @click="signOut">
              <a>Sign Out</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>

        <!-- Remaining Wallet Balance -->
        <div class="wallet-balance" v-if="billing && !is_wallet_hidden" @click="goToBilling">
          <p><span>${{ billing.wallet_balance.toFixed(2) }}</span> Remaining</p>
        </div>

      </div>

    </div>
    <!-- End of wrapper-nav -->


    <!-- Questions, Answers and All Respondents Header -->
    <center>

      <div class="title-container" v-if="['answers', 'questions', 'respondents', 'settings'].includes(page)">
        <div class="title">

          <!-- <img v-if="question_image" :src="question_image"/> -->
          <h1 v-bind:title="title" :class="{ smallerFont: title.length > 120, mediumFont: (title.length > 50 && title.length <= 120) }">
            <template v-if="page === 'questions'">{{ survey_emoji }}&nbsp;&nbsp;{{ truncateTitle(title) }}</template>
            <template v-if="page === 'answers'">{{ (Number(question_index) + 1) }}. {{ truncateTitle(title) }}</template>
            <template v-if="page === 'respondents'">{{ title }}</template>
            <template v-if="page === 'settings'">{{ title }}</template>
          </h1>

        </div>

      </div>
    </center>


    <!-- Respondent Page Header -->
    <center>
      <div v-if="page === 'respondent' && respondent" class="title-container-respondent">
        <img :src="respondent.profile_pic">
        <h1>{{ respondent.uid }}</h1>
        <div class="delete-respondent" v-if="!is_demo_survey">
          <template>
            <a-popconfirm title="Remove this user and all their answers?" @confirm="confirmDeleteRespondent" okText="Yes" cancelText="Cancel">
              <a-icon class="delete-btn" type="delete" theme="filled" />
            </a-popconfirm>
          </template>
        </div>
      </div>
    </center>

  </section>

</template>

<script>

import { db_helper } from '../store/db_helper.js';

export default {
  name: 'Header',
  props: {
    page: String,
    title: String,
    question_image: String,
    uid: String
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    name() {
      return this.user.name || "";
    },
    respondent() {
      return this.$store.state.respondents[this.$route.params.uid];
    },
    gender_first_letter() {
      if (this.respondent && this.respondent.gender) {
        return this.respondent.gender.charAt(0).toUpperCase();
      } else {
        return "";
      }
    },
    survey_index() {
      return this.$route.params.survey_index;
    },
    survey() {
      if (this.survey_index !== undefined && this.$store.state.surveys) {
        return this.$store.state.surveys[this.survey_index];
      } else {
        return null;
      };
    },
    survey_emoji() {
      return this.survey ? this.survey.emoji_icon : '';
    },
    is_demo_survey() {
      return this.survey ? this.survey.id === "cNUZcoeTjtX1h9vUEama" : false;
    },
    question_index() {
      if (this.page === "answers") {
        return this.$route.params.question_index;
      } else {
        return 0;
      }
    },
    question_type() {
      if (this.question_index !== undefined && this.survey) {
        let answer_type = this.survey.questions[this.question_index].answer_type;
        switch (answer_type) {
          case 'text':
            return '✏️';
          case 'audio':
            return '🎙';
          case 'image':
            return '📷';
          case 'video':
            return '🎬';
          case 'multi_choice':
            return '📊';
          case 'location':
            return '📍';
          case 'nps':
            return '⚖️';
          case 'multimedia':
            return '▶️';
          case 'say':
            return '💬';
          default:
            return '';
        };
      }
    },

    billing() {
      return this.$store.state.billing;
    },
    is_wallet_hidden() {
      if (this.$store.state.user && this.$store.state.user.settings) {
        return this.$store.state.user.settings.is_wallet_hidden === true;
      } else {
        return false;
      };
    }

  },
  methods: {

    signOut: function() {
      this.$auth.signOut().then(
        () => {
          this.$router.replace('/');
        }, error => {
          alert(error.message);
        }
      );
    },

    truncateTitle(text) {
      if (text.length > 235) {
        return `${text.slice(0,235)}...`
      } else {
        return text;
      }
    },

    // Remove all a respondents answers from the survey
    confirmDeleteRespondent(e) {

      let respondent_id = this.$route.params.uid;
      let survey_index = this.$route.params.survey_index;

      this.$store.dispatch('deleteAllRespondentsAnswers', [respondent_id, survey_index]);

      this.$router.replace(`/surveys/${survey_index}/questions`);
      this.$message.success(`Respondent's answers removed from survey`, 3); // Show error message for 3 seconds
      analytics.track('Respondent Deleted');

    },

    goToSettings() {
      this.$router.push(`/settings`);
    },

    goToBilling() {
      this.$router.push(`/settings#billing`);
    },

    goToFeedback() {
      this.$router.replace(`/feedback`);
    },

    goToPage(page) {
      this.$router.push({ name: page, params: { survey_index: this.survey_index } });
    }

  }

}
</script>

<style scoped lang="scss">

// TODO: Put this values in a mixins file.
$light-green: #12B16D;
$dark-green: rgb(22,127,170);

section {
  width: 100%;
  background: linear-gradient(135deg, $dark-green 0%,$light-green 100%);
  height: auto;
  min-height: 190px;
  max-height: 220px;
  padding-top: 50px;
  font-family: "Montserrat", sans-serif;
  position: relative;
  &.share{
    min-height: 500px;
    max-height: 500px;
  }
}

.nav-wrapper{
  width: 980px;
  height: 44px;
  margin: 0 auto;
  padding-top: 10px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}


#logo{
  width: 180px;
  //margin-top: 14px;
}


#navigation{
  background-color: rgba(255,255,255,.15);
  height: 38px;
  width: 221px;
  border-radius: 25px;
  position: relative;
  transform: translateX(-53px);

  &.answers_selected{
    width: 305px;
  }
  &.respondent_selected{
    width: 273px;
  }
  &.respondents_selected{
    width: 283px;
  }

  .button-container{
    position: absolute;
      top: 0;
      left: 0;
    z-index: 1;

    button{
      background-color: transparent;
      height: 36px;
      color: rgba(255,255,255,.5);
      font-size: 15px;
      font-weight: 600;
      border: none;
      transition: all 0.2s ease;
      cursor: pointer;

      &:focus{
        outline: none;
      }
      &.selected{
        color: #146287;
        &:hover{
          color: #146287;
        }
      }
      &.sub_selected{
        color: rgba(255,255,255,.7);
        &:hover{
          color: white;
        }
        background-color: rgba(255,255,255,.15);
        border-radius: 30px 0px 0px 30px;
      }
      &:hover{
        color: rgba(255,255,255,1);
      }
      background-size: 18px;
      background-position: right;
      background-repeat: no-repeat;
    }

    #share-page-btn{
      width: 90px;
      background-image: url("../assets/whatsapp-logo.svg");
      padding-right: 10px;
    }

    #results-page-btn{
      margin-left: 15px;
      padding-left: 15px;
      width: 113px;
    }

    #answers-page-btn{
      width: 86px;
      background-color: rgba(255,255,255,.15);
      border-radius: 0px 30px 30px 0px;
    }

    #respondent-page-btn{
      width: 55px;
      background-color: rgba(255,255,255,.15);
      border-radius: 0px 30px 30px 0px;
    }

    #respondents-page-btn{
      width: 65px;
      background-color: rgba(255,255,255,.15);
      border-radius: 0px 30px 30px 0px;
    }

  }

  #selected-slider{
    background-color: white;
    width: 110px;
    height: 38px;
    position: absolute;
      top: 0;
      left: 0;
    border: 1px solid #117580;
    border-radius: 25px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
    z-index: 0;
    transition: all 0.1s ease;
    &.results_selected{
      width: 118px;
      left: 103px;
    }
    &.answers_selected{
      width: 88px;
      left: 218px;
    }
    &.respondent_selected{
      width: 55px;
      left: 218px;
    }
    &.respondents_selected{
      width: 67px;
      left: 218px;
    }
  }

}



.dropdown-container{
  position: relative;
}

.wallet-balance{
  position: absolute;
    top: 50px;
    right: 0px;
  p{
    color: white;
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    text-align: right;
    margin-bottom: 12px;
    cursor: pointer;
    opacity: .9;
    transition: all 0.2s ease;
    &:hover{
      opacity: 1;
      text-decoration: underline;
    }
    span{
      font-weight: 600;
    }
  }
}


.title-container{
  background-color: white;
  display: inline-block;
  max-width: 850px;
  border-radius: 8px;
  padding: 20px 30px 12px 30px;
  margin: 0 auto;
  transform: translateY(30px);
  border: 1px solid #ECECEC;
  box-shadow: 0 0 12px 0 rgba(0,0,0,.2);
  &>*{
    display: inline-block;
    vertical-align: middle;
  }
  img{
    height: 60px;
    margin: -8px 20px 0px -15px;
    border-radius: 4px;
  }
  h1{
    font-size: 25px;
    font-weight: 700;
    text-align: center;
    color: #0D303F;
    max-width: 820px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    &.smallerFont{
      font-size: 18px;
    }
    &.mediumFont{
      font-size: 22px;
    }
  }
}


.title-container-respondent{
  background-color: white;
  display: inline-block;
  max-width: 970px;
  border-radius: 6px;
  padding: 20px 27px 25px 27px;
  margin: 0 auto;
  margin-top: 80px;
  border: 1px solid #ECECEC;
  box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
  & > img{
    object-fit: cover;
    width: 120px;
    height: 120px;
    margin-top: -80px;
    margin-bottom: 17px;
    border-radius: 10px;
    box-shadow: 0 0 12px 0 rgba(0,0,0,.2);
  }
  h1{
    font-size: 22px;
    font-weight: 700;
    text-align: center;
    color: #0D303F;
  }
  .demographics-container{
    margin-top: 4px;
    & > *{
      display: inline-block;
    }
    img{
      width: 18px;
      height: 18px;
      margin-right: 3px;
      margin-top: -2px;
    }
    p{
      font-size: 15px;
      font-weight: 600;
      color: #0D303F;
      &:first-of-type{
        margin-right: 10px;
      }
    }
  }
  .delete-respondent{
    .delete-btn{
      font-size: 16px;
      opacity: .4;
      &:hover{
        cursor: pointer;
        opacity: .55;
        transform: scale(1.075, 1.075);
        transition: all 0.3s ease;
      }
    }
    .favorite-btn{

    }
  }
}

.ant-dropdown-link{
  color: white;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: .5px;
}


/*************

MOBILE STYLES

*************/


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

section{
  min-height: 90px;
  max-height: 130px;
  padding-top: 25px;
}

.nav-wrapper{
  width: 100%;
  padding: 10px 25px;
}

.breadcrumbs{
  display: none;
}

.title-container{
  max-width: 90%;
  padding: 15px 25px 19px 25px;
  transform: translateY(0px);
  h1{
    font-size: 18px;
    margin: 0;
    &.mediumFont{
      font-size: 15px;
    }
  }
}

.title-container-respondent{
  margin-top: 50px;
  img{
    height: 80px;
    width: 80px;
  }
}

.wallet-balance,
#navigation{
  display: none;
}

}


/* Ipad Portrait */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
  .nav-wrapper{
    width: 100%;
    padding: 10px 50px;
  }
  .title-container{
    max-width: 90%;
  }
}



</style>
